/**
 * Texte des Hauptadmin-Bereichs (10_main_admin.md).
 *
 * Der Systemadmin ist ein Verwaltungs- und Supportkonto; die Oberfläche soll
 * bewusst schlicht bleiben. Was es hier nicht gibt, ist ebenso Absicht wie
 * das, was da ist: keine Datensatzliste, keine Leadsuche.
 */
export const dePlatform = {
  'platform.nav.tenants': 'Kunden',
  'platform.nav.settings': 'Einstellungen',
  'platform.nav.main': 'Hauptnavigation',
  'platform.role': 'Systemadministration',

  // --- Kundenliste --------------------------------------------------------
  'platform.tenants.title': 'Kunden',
  'platform.tenants.empty': 'Es ist noch kein Kunde registriert.',
  'platform.tenants.customer': 'Kunde',
  'platform.tenants.email': 'E-Mail',
  'platform.tenants.registered': 'Registriert',
  'platform.tenants.status': 'Status',
  'platform.tenants.callers': 'Caller',
  'platform.tenants.campaigns': 'Kampagnen',
  'platform.tenants.balance': 'Guthaben',
  'platform.tenants.price': 'Minutenpreis',
  'platform.tenants.minutes': 'Minuten',
  'platform.tenants.open': 'Öffnen',
  'platform.tenants.paymentsLater':
    'Bezahlte Aufladungen und vergebenes Bonusguthaben kommen mit dem Zahlungsteil dazu.',

  'platform.status.active': 'Aktiv',
  'platform.status.suspended': 'Gesperrt',
  'platform.status.deleted': 'Gelöscht',

  // --- Kundendetail -------------------------------------------------------
  'platform.tenant.back': 'Zurück zu den Kunden',
  'platform.tenant.account': 'Konto',
  'platform.tenant.customerNumber': 'Kundennummer',
  'platform.tenant.accountName': 'Firmen-/Kontoname',
  'platform.tenant.owner': 'Kontoinhaber',
  'platform.tenant.language': 'Sprache',
  'platform.tenant.suspend': 'Konto sperren',
  'platform.tenant.unsuspend': 'Konto freigeben',
  'platform.tenant.suspendTitle': 'Konto sperren',
  'platform.tenant.suspendText':
    'Alle laufenden Gespräche enden sofort, alle Benutzer werden abgemeldet und können sich nicht mehr anmelden. Sie können das Konto jederzeit wieder freigeben.',

  'platform.tenant.usage': 'Nutzung',
  'platform.tenant.balance': 'Guthaben',
  'platform.tenant.balanceAdd': 'Guthaben hinzufügen',
  'platform.tenant.balanceSubtract': 'Guthaben abziehen',
  'platform.tenant.balanceAmount': 'Betrag in Euro',
  'platform.tenant.balanceNote': 'Grund - der Kunde sieht ihn',
  'platform.tenant.balanceNotePlaceholder': 'z. B. Kulanz wegen Störung',
  'platform.tenant.balanceBookings': 'Letzte Buchungen',
  'platform.tenant.balanceEmpty': 'Es gibt noch keine Buchungen.',
  'platform.tenant.balanceAvailable': 'Verfügbar',
  'platform.tenant.balanceDebitTitle': 'Guthaben abziehen',
  'platform.tenant.balanceDebitText':
    'Der Betrag wird dem Kunden sofort abgezogen. Der Grund erscheint in seiner Zahlungshistorie.',
  'platform.tenant.balanceDebitConfirm': 'Jetzt abziehen',
  'platform.tenant.balanceInternalNote': 'Interner Hinweis',
  'platform.tenant.usageMinutes': 'Abgerechnete Minuten',
  'platform.tenant.usageToday': 'Minuten heute',
  'platform.tenant.usageConnected': 'Verbundene Gespräche',
  'platform.tenant.usageAttempts': 'Anwahlversuche',
  'platform.tenant.usageLast': 'Letztes Gespräch',

  'platform.tenant.export': 'Kundendatenexport',
  'platform.tenant.exportHint':
    'Eine ZIP-Datei mit einer CSV je Kampagne. Jede Kampagne hat eigene Felder, deshalb eine Datei pro Kampagne.',
  'platform.tenant.exportAction': 'Alle Kundendaten herunterladen',
  'platform.tenant.exportScope':
    'Enthalten ist der reguläre Datenbestand. Archivierte und kundenseitig gelöschte Daten liegen im Archiv.',

  'platform.tenant.settings': 'Kundeneinstellungen',
  'platform.tenant.settingsHint': 'Nur zur Ansicht - geändert werden sie vom Kunden selbst.',
  'platform.tenant.settingsCountries': 'Ländervorwahlen',
  'platform.tenant.settingsInbound': 'Kampagnen mit eingehenden Anrufen',
  'platform.tenant.settingsQueue': 'Kampagnen mit Warteschleife',
  'platform.tenant.settingsRecording': 'Kampagnen mit Aufnahme',

  'platform.tenant.archive': 'Archiv und Löschen',
  'platform.tenant.archiveSoon':
    'Das Archiv kundenseitig gelöschter Daten und das endgültige Löschen entstehen in einem der nächsten Schritte.',

  // --- Live-Gespräche -----------------------------------------------------
  'platform.live.title': 'Live-Gespräche',
  'platform.live.hint': 'Nur Gespräche, bei denen gerade miteinander gesprochen wird.',
  'platform.live.empty': 'Gerade läuft bei diesem Kunden kein Gespräch.',
  'platform.live.campaign': 'Kampagne',
  'platform.live.caller': 'Caller',
  'platform.live.customer': 'Kunde',
  'platform.live.duration': 'Dauer',
  'platform.live.listen': 'Zuhören',
  'platform.live.stopListening': 'Zuhören beenden',
  'platform.live.listening': 'Sie hören zu',
  'platform.live.silent':
    'Sie hören ausschließlich zu. Sprechen ist nicht möglich, und niemand im Gespräch erfährt davon.',

  // --- Aufnahmen ----------------------------------------------------------
  'platform.recordings.title': 'Aufnahmen',
  'platform.recordings.hint': 'Kampagnenweiser Download. Aufnahmen werden nach 30 Tagen endgültig gelöscht.',
  'platform.recordings.campaign': 'Kampagne',
  'platform.recordings.count': 'Vorhanden',
  'platform.recordings.range': 'Zeitraum',
  'platform.recordings.download': 'Alle als ZIP',
  'platform.recordings.empty': 'Für diesen Kunden liegen keine Aufnahmen vor.',
  'platform.recordings.none': 'keine',
  'platform.recordings.notYet':
    'Die Aufnahmefunktion selbst entsteht in einem der nächsten Schritte. Bis dahin bleibt diese Liste leer.',

  'platform.period.today': 'Heute',
  'platform.period.week': 'Woche',
  'platform.period.month': 'Monat',
  'platform.period.all': 'Alle',
  'platform.period.label': 'Zeitraum',
  'platform.period.help':
    'Gerechnet wird nach Serverzeit: Heute ab 00:00 Uhr, Woche ab Montag 00:00 Uhr, Monat ab dem Ersten.',

  // --- Globale Einstellungen ----------------------------------------------
  'platform.settings.title': 'Globale Einstellungen',
  'platform.settings.price': 'Standard-Minutenpreis',
  'platform.settings.startCredit': 'Startguthaben',
  'platform.settings.minTopUp': 'Mindestbetrag Guthabenaufladung',
  'platform.settings.minTopUpHint':
    'Gilt nur, wenn ein Kunde selbst Guthaben auflädt. Für Ihre eigenen Buchungen gilt er nicht.',
  'platform.settings.retryInterval': 'Mindestabstand für Wiederholungen (Minuten)',
  'platform.settings.supportEmail': 'Support-E-Mail',
  'platform.settings.saved': 'Die Einstellungen wurden gespeichert.',
  'platform.settings.smtpSoon': 'Die SMTP-Einstellungen entstehen mit dem E-Mail-Teil.',

  // --- Fehlermeldungen des Servers ---------------------------------------
  'error.tenant.not_found': 'Dieser Kunde wurde nicht gefunden.',
  'error.call.not_found': 'Dieses Gespräch läuft nicht mehr.',
  'error.monitoring.unavailable': 'Das Gespräch kann gerade nicht mitgehört werden.',
  'error.recordings.invalid_period': 'Bitte einen gültigen Zeitraum wählen.',
  'error.auth.platform_admin_required': 'Dieser Bereich ist nicht verfügbar.',
} as const;
